import React from "react";

const Bash_Ssh = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Ssh</h2>
      <p>Open a secure shell connection to a remote host.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>ssh [user@]hostname</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>ssh user@server.example.com
ssh -p 2222 user@host</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Set up SSH keys for passwordless login.</p>
    </div>
  );
};

export default Bash_Ssh;
